<template>
  <div class="delivery">
    <back-header title="填写发货信息" />
    <scroll clickable>
      <refund-goods v-for="item in goods" :key="item.id" :goods="item" />
      <div class="form">
        <div class="input" @click="showPicker=true">
          <label :class="{active: company}">{{ company || '请选择快递公司' }}</label>
          <van-icon class="icon-right" name="arrow" />
        </div>
        <div class="input">
           <input v-model="express_no" type="text" placeholder="请输入物流单号" />
          <van-icon class="scan-icon" name="scan" />
        </div>
      </div>
    </scroll>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="confirm"
      />
    </van-popup>
    <div class="bottom-btn" @click="submit">确认已发货</div>
  </div>
</template>

<script>
import BackHeader from '../../components/back-header/back-header'
import Scroll from '../../components/scroll/scroll'
import RefundGoods from '../../components/refund-goods/refund-goods'
import { post } from '../../common/js/http'

export default {
  name: 'delivery',
  components: {
    BackHeader,
    RefundGoods,
    Scroll
  },
  data() {
    return {
      showPicker: false,
      columns: ['圆通速递', '韵达快递', '中通快递', '顺丰速运', '邮政快递包裹', '百世快递', '京东物流', '申通快递', '天天快递', 'EMS', '邮政标准快递', '德邦', '德邦快递', '韵达快运', '百世快运', '中通快运', '圆通快运\n'],
      company: '',
      goods: {},
      express_no: ''
    }
  },
  created() {
    this.goods = this.$route.params.goods
  },
  methods: {
    confirm(val) {
      this.company = val
      this.showPicker = false
    },
    submit() {
      if (!this.express_no) {
        this.$toast.fail('请输入物流单号')
        return
      }
      const loading = this.$toast.loading()
      post('/shop/order/deliveryOrder', {
        suborderid: this.$route.params.orderId,
        express_no: this.express_no,
        express_company: this.company
      })
        .then(() => {
          this.$router.goBack()
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    }
  }
}
</script>

<style scoped lang="stylus">
  @import "../../common/style/variable.styl"
  ::v-deep
    .van-ellipsis
      font-size 28px
    .van-picker__cancel
      font-size 28px
    .van-picker__confirm
      font-size 28px
      color $mall-theme-color
    .van-picker__toolbar
      height 80px
.delivery
  padding-bottom 132px
  padding-top 86px
  height 100%
  box-sizing border-box
  background #f4f4f4
  .form
    margin-top 20px
    margin-bottom 74px
    background #fff
    .input
      height 115px
      display flex
      align-items center
      padding 0 30px
      justify-content space-between
      &>label
        font-size 30px
        color #979797
        &.active
          color #000
      .icon-right
        font-size 24px
        color #AEAEAE
      &>input
        flex 1
        margin-right 20px
        font-size 30px
        color #000
        height 100%
        border none
        outline none
        &::-webkit-input-placeholder
          color #979797
      .scan-icon
        font-weight bold
        font-size 34px
</style>
